export const CREATE_TYPE = 'create-type';
export const TIME_TYPE = 'time-type';
export const RESPONSIBLE_TYPE = 'responsible-type';
export const LABEL_TYPE = 'label-type';
export const CLOSE_TYPE = 'close-type';
export const REOPEN_TYPE = 're-open-type';
export const UPDATE_TYPE = 'update-type';
export const COMMENT_TYPE = 'comment-type';
export const COMMENT_DELETE_TYPE = 'comment-delete-type';
export const MENTION_TYPE = 'mention-type';
export const DELETE_TYPE = 'delete-type';
export const EDIT_TYPE = 'edit-type';
export const ADD_TEAM_TYPE = 'add-team-type';
export const APPROVAL_TYPE = 'approval-type';
export const TASK_MENTION_TYPE = 'task-mention-type';
export const MONITORING_TYPE = 'monitoring-type';
export const REACT_TYPE = 'react-type';
export const MIGRATE_TYPE = 'migrate-type';
export const COMMENT_MIGRATE_TYPE = 'comment-migrate-type';
export const CHECKLIST_TYPE = 'checklist-type';
// Extra
export const BATCH_UPDATE_TYPE = 'batch-update-type';
